import { z } from 'zod';

import { AfcCandidateSearchSchema } from './afc-candidate-search';

export const TalentSearchResponseMetaSchema = z.object({
  currentPage: z.number().nonnegative().int(),
  pageCount: z.number().nonnegative().int(),
  resultCount: z.number().nonnegative().int(),
  aggregations: z.number().nonnegative().int().nullable(),
});

export type TalentSearchResponseMeta = z.infer<
  typeof TalentSearchResponseMetaSchema
>;

export const TalentSearchResponseSchema = z.object({
  meta: TalentSearchResponseMetaSchema,
  data: z.array(AfcCandidateSearchSchema),
});

export type TalentSearchResponse = z.infer<typeof TalentSearchResponseSchema>;
